import { jsx as _jsx } from "react/jsx-runtime";
import { cloneElement, createContext, useCallback, useState, } from "react";
import { Editor, Transforms } from "slate";
import { useDeserialize } from "../serialize";
import { focusEditor as _focusEditor } from "../utils";
import { getPluginOptions } from "../utils/plugin-utils";
const nest = (children, component) => cloneElement(component, {}, children);
// @ts-ignore
const FluentEditCtx = createContext(undefined);
function FluentEditProvider({ children, providers = [], }) {
    const [editor, setEditor] = useState(undefined);
    const [multiline, setMultiline] = useState(false);
    const [plugins, setPlugins] = useState([]);
    const deserializer = useDeserialize(plugins);
    const focusEditor = useCallback(() => {
        if (editor) {
            _focusEditor(editor);
        }
    }, [editor]);
    const resetEditor = useCallback((text = "") => {
        if (editor) {
            Editor.withoutNormalizing(editor, () => {
                Transforms.delete(editor, {
                    at: [0],
                });
                const nodes = deserializer(text, multiline, getPluginOptions(plugins, children));
                Transforms.insertNodes(editor, nodes);
                focusEditor();
            });
        }
    }, [editor, deserializer, multiline, plugins, focusEditor, children]);
    const value = {
        editor,
        setEditor,
        focusEditor,
        resetEditor,
        multiline,
        setMultiline,
        plugins,
        setPlugins,
    };
    return (_jsx(FluentEditCtx.Provider, Object.assign({ value: value }, { children: providers.reduceRight(nest, children) })));
}
export default FluentEditProvider;
export { FluentEditCtx };
